<template>
    <div
        class="wrapper__location"
        id="menu-gotomap-btn"
        @click="gotoPage()"
    >
        <div class="location-text">
            <div class="location-header">
                <img class="top-button" src="@/assets/home/location_icon.svg" />
                <span>สาขาใกล้เคียง</span><span v-if="showStar" class="red-star">*</span>
            </div>
            <div class="location-content">
                <span v-if="'location' in getLocationStore">{{
                    getLocationStore.location
                }}</span>
                <span v-else>ค้นหาสาขาที่นี่</span>
            </div>
        </div>
        <div class="location-arrow">
            <img class="top-button" src="@/assets/home/white_dropdown.svg" />
        </div>
    </div>
</template>

<script>
//core
import MenuApi from "@/module/Menu/service/missionbadge.js";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "LocationDropdown",
    props: {
        path: String,
        showStar: Boolean
    },
    computed: mapGetters(["getLocationStore"]),
    data() {
        return {
            center: { lat: 13.7446841, lng: 100.5633786 }, //default
        }
    },
    watch: {
        getCallback(newVal, oldVal) {
            if (newVal != oldVal) {
                const getLocation = this.getLocation();

                Promise.all([getLocation])
                    .then(() => {
                        this.orderCafeName();
                        this.handleLoading(false);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }
    },
    created() {
        this.getUserLocation();
    },
    methods: {
        gotoPage: function() {
            this.$router.push('cafemap/' + this.path);
        },
        getUserLocation() {
            return new Promise(resolve => {
                window.navigator.geolocation.getCurrentPosition(
                    this.successHandler,
                    this.errorHandler,
                    { enableHighAccuracy: true, maximumAge: 10000 }
                );
                resolve(true);
            });
        },
        successHandler: function(position) {
            this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            this.getCallback = true;
        },
        errorHandler: function(errorObj) {
            alert(
                errorObj.code +
                    ": " +
                    errorObj.message +
                    " use default location"
            );
            this.getCallback = true;
        },
        getLocation() {
            return new Promise((resolve, reject) => {
                if (this.getLocationStore.location) {
                    resolve(true);
                }
                this.form = `${this.center.lat},${this.center.lng}`;
                MenuApi.GetCafeLocation(this.distance, this.form).subscribe(
                    response => {
                        response.forEach(element => {
                            this.markers.push({
                                position: {
                                    lat: element.location.latitude,
                                    lng: element.location.longitude
                                },
                                name: element.name,
                                distance: Math.trunc(
                                    element.distance / 1000
                                ).toLocaleString("en-US")
                            });
                        });
                        console.log(this.markers);
                        resolve(response);
                    },
                    err => {
                        console.log(err);
                        reject(err);
                    }
                );
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.red-star {
    color: #e1261c;
}
</style>
